import React, { Component } from "react";
import { connect } from "react-redux";
import { string, shape, oneOfType, bool } from "prop-types";

import { selectors as i18nSelectors } from "reducers/i18n";
import I18n from "pages/_components/I18n";

class ViewTitle extends Component {
    static propTypes = {
        defaultValue: string,
        id: string,
        align: string,
        lightText: bool,
        accessibilityTextId: oneOfType([string, bool]),
        replace: shape({ USER_NAME: string }),
    };

    static defaultProps = {
        defaultValue: null,
        accessibilityTextId: null,
        align: "",
        lightText: false,
        replace: { USER_NAME: null },
        id: null,
    };

    render() {
        const { id, replace, defaultValue, accessibilityTextId, align, lightText } = this.props;
        const titleComponent = accessibilityTextId ? "p" : "h1";

        return (
            <>
                {accessibilityTextId && (
                    <I18n id={accessibilityTextId} component="h1" componentProps={{ className: "visually-hidden" }} />
                )}

                <I18n
                    id={id}
                    defaultValue={defaultValue}
                    component={titleComponent}
                    componentProps={{ className: `title-content ${align} ${lightText && "light-text"}` }}
                    {...replace}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    activeLanguage: i18nSelectors.getLang(state),
});

export default connect(mapStateToProps)(ViewTitle);
